<input [class]="inputClass" type="search" placeholder="Selecione" [(ngModel)]="valorInput" [matAutocomplete]="auto"
  (blur)="tocar()">
<mat-autocomplete [displayWith]="exibir" #auto="matAutocomplete">
  <mat-option value>
    Selecione
  </mat-option>
  <mat-option *ngFor="let dado of dadosFiltrados" [value]="valor(dado)">
    {{exibir(dado)}}
  </mat-option>
</mat-autocomplete>